import { Controller } from 'react-hook-form';
import { InputGroup, NumberInput } from 'rsuite';
import { FormGroup } from '@shared/ui/forms/display';
import { icons } from '@shared/static/icons';

export default function QuantityInput({
  error,
  control,
  name,
  label,
  max,
  hint,
  disabled = false,
}) {
  return (
    <FormGroup label={label} hint={hint} error={error}>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <InputGroup
            disabled={disabled}
            inside
            className={`${field.value ? 'has-value' : ''}`}
          >
            <InputGroup.Button
              className="clickable"
              onClick={() => {
                const current = Number(field.value) || 0;
                if (current === 1) return;
                if (!Number.isInteger(current)) {
                  field.onChange(Math.round(current));
                  return;
                }
                field.onChange(current - 1);
              }}
            >
              {icons.minus}
            </InputGroup.Button>
            <NumberInput
              value={field.value}
              onChange={(value) => {
                if (Number(value) !== 0 && !Number.isInteger(value)) {
                  field.onChange(Math.round(value));
                  return;
                }
                field.onChange(value);
              }}
              min={1}
              max={max}
              onBlur={(e) => {
                if (Number(e.target.value) === 0) {
                  field.onChange(1);
                }
              }}
            />
            <InputGroup.Button
              className="clickable"
              onClick={() => {
                const current = Number(field.value) || 0;
                if (!Number.isInteger(current)) {
                  field.onChange(Math.round(current));
                  return;
                }
                if (current + 1 > max) {
                  field.onChange(max);
                  return;
                }
                field.onChange(current + 1);
              }}
            >
              {icons.plus}
            </InputGroup.Button>
          </InputGroup>
        )}
      />
    </FormGroup>
  );
}
